/* Fiche console portable (template product.handheld) : galerie, variantes, lots, compléments, panier, accordéons, dates, compte à rebours. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '£{{amount}}';
    function delim(n, prec, th, dec) {
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* Prix au format du pays (mêmes règles que snippets/hc-money.liquid) : 119,90 € (FR, DE…), €119.90 (IE), € 119,90 (NL), £104.90, CHF 119.90, $209.90. */
  function hcMoney(cents, code, cc) {
    if (!code) return '';
    cents = Math.round(Number(cents) || 0);
    var style = 'before', sym = code + ' ', dec = '.', th = ',';
    if (code === 'EUR') {
      sym = '€';
      if (cc && 'FR BE LU DE AT ES IT PT FI GR HR CY EE LV LT SK SI'.split(' ').indexOf(cc) > -1) {
        style = 'after'; dec = ','; th = 'FR BE LU FI SK EE LV LT'.split(' ').indexOf(cc) > -1 ? '\u00a0' : '.';
      } else if (cc === 'NL') { style = 'before_space'; dec = ','; th = '.'; }
    } else if (code === 'GBP') sym = '£';
    else if (code === 'USD' || code === 'CAD' || code === 'AUD') sym = '$';
    else if (code === 'CHF') { sym = 'CHF'; style = 'before_space'; th = '\u2019'; }
    var whole = Math.floor(cents / 100), frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, th);
    var amount = w + dec + frac;
    if (style === 'after') return amount + '\u00a0' + sym;
    if (style === 'before_space') return sym + '\u00a0' + amount;
    return sym + amount;
  }

  /* ---------- Accordéons (hauteur animée) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hc-acc]');
    if (!btn) return;
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (open) {
      body.style.height = body.scrollHeight + 'px';
      requestAnimationFrame(function () { body.style.height = '0px'; });
    } else {
      body.style.height = body.scrollHeight + 'px';
      body.addEventListener('transitionend', function te() { if (btn.getAttribute('aria-expanded') === 'true') body.style.height = 'auto'; body.removeEventListener('transitionend', te); });
    }
  });

  /* ---------- Carrousels simples (galerie, mini avis) ---------- */
  function track(trackEl, onChange) {
    var idx = 0;
    function count() { return trackEl.children.length; }
    function go(i, smooth) {
      var n = count(); if (!n) return;
      idx = (i + n) % n;
      trackEl.scrollTo({ left: trackEl.children[idx].offsetLeft - trackEl.children[0].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      onChange && onChange(idx);
    }
    var t;
    trackEl.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = trackEl.clientWidth || 1;
        var i = Math.round(trackEl.scrollLeft / w);
        if (i !== idx) { idx = i; onChange && onChange(idx); }
      }, 60);
    }, { passive: true });
    return { go: go, get index() { return idx; } };
  }

  function initGallery(gal) {
    var tr = $('[data-hc-track]', gal);
    if (!tr) return null;
    var thumbs = $$('.hc-gal__thumb', gal);
    var dots = $$('.hc-gal__dots span', gal);
    var zoom = $('[data-hc-zoom]', gal);
    var api = track(tr, function (i) {
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var th = thumbs[i];
      var strip = th && th.parentElement;
      if (th && strip) strip.scrollTo({ left: th.offsetLeft - strip.offsetLeft - (strip.clientWidth - th.clientWidth) / 2, behavior: 'smooth' });
      var img = tr.children[i] && tr.children[i].querySelector('img');
      if (zoom && img) zoom.href = img.currentSrc || img.src;
    });
    var prev = $('[data-hc-prev]', gal), next = $('[data-hc-next]', gal);
    prev && prev.addEventListener('click', function () { api.go(api.index - 1); });
    next && next.addEventListener('click', function () { api.go(api.index + 1); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { api.go(k); }); });
    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        var slides = Array.prototype.slice.call(tr.children);
        for (var k = 0; k < slides.length; k++) if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { api.go(k); return; }
      }
    };
  }

  function initReviews(rv) {
    var tr = $('[data-hc-rv-track]', rv);
    var dots = $$('.hc-rv__dots span', rv);
    if (!tr || dots.length < 2) return;
    var api = track(tr, function (i) { dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); });
    var sec = parseInt(rv.getAttribute('data-autoplay'), 10); if (isNaN(sec)) sec = 5;
    if (sec <= 0) return;
    var timer = setInterval(function () { api.go(api.index + 1); }, sec * 1000);
    tr.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
  }

  /* ---------- Dates de livraison ---------- */
  function ordinal(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate()); }
  function plus(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function range(a, b) { return a === b ? fmt(plus(a)) : fmt(plus(a)) + ' - ' + fmt(plus(b)); }
  function initShip(el) {
    var g = function (k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; };
    var d0 = $('[data-hc-d0]', el), d1 = $('[data-hc-d1]', el), d2 = $('[data-hc-d2]', el);
    if (d0) d0.textContent = fmt(new Date());
    if (d1) d1.textContent = range(g('ready-min'), Math.max(g('ready-min'), g('ready-max')));
    if (d2) d2.textContent = range(g('del-min'), Math.max(g('del-min'), g('del-max')));
  }

  /* ---------- Compte à rebours (date fixe réglée dans l'éditeur) ---------- */
  function initCountdown(el) {
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.hidden = true; return; }
    var h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el), d = $('[data-d]', el), dw = $('[data-dwrap]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(iv); return; }
      var days = Math.floor(left / 86400);
      if (dw) dw.hidden = days === 0;
      if (d) d.textContent = pad(days);
      h.textContent = pad(Math.floor((days ? left % 86400 : left) / 3600));
      m.textContent = pad(Math.floor(left % 3600 / 60));
      s.textContent = pad(left % 60);
      el.hidden = false;
    }
    var iv = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Panier ---------- */
  function addToCart(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    url = url.replace('.js.js', '.js');
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'Error');
        if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hc-pdp', cartData: json }); } catch (e) {} }
        if (drawer && json.sections && typeof drawer.renderContents === 'function') {
          json.id = items[0].id;
          drawer.classList.remove('is-empty');
          drawer.renderContents(json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return json;
      });
  }

  /* ---------- Bloc achat ---------- */
  function initMain(root) {
    var dataEl = $('[data-hc-product]', root);
    if (!dataEl) return;
    var P;
    try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var gallery = initGallery($('[data-hc-gal]', root) || root);
    var optsEl = $('[data-hc-opts]', root);
    var nOpts = P.variants[0] ? P.variants[0].options.length : 0;

    function findVariant(opts) {
      for (var i = 0; i < P.variants.length; i++) {
        var v = P.variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) if (v.options[k] !== opts[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function selected() {
      if (!optsEl) return P.variants[0] ? P.variants[0].options.slice() : [];
      var out = [];
      for (var k = 0; k < nOpts; k++) {
        var c = $('[data-hc-opt="' + k + '"] input:checked', optsEl);
        out.push(c ? c.value : (P.variants[0] && P.variants[0].options[k]));
      }
      return out;
    }
    function money(c) { return hcMoney(c, P.currency, P.country) || formatMoney(c, P.moneyFormat); }

    var current = findVariant(selected()) || P.variants[0];

    function markAvailability(opts) {
      if (!optsEl) return;
      for (var k = 0; k < nOpts; k++) {
        $$('[data-hc-opt="' + k + '"] input', optsEl).forEach(function (inp) {
          var test = opts.slice(); test[k] = inp.value;
          var v = findVariant(test);
          var item = inp.parentElement;
          item.classList.toggle('is-off', !v || !v.available);
        });
      }
    }

    function updatePrice(v) {
      var now = $('[data-hc-now]', root), was = $('[data-hc-was]', root), badge = $('[data-hc-badge]', root);
      if (now) now.textContent = money(v.price);
      var pct = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
      if (was) { was.textContent = money(v.compare); was.hidden = pct === 0; }
      if (badge) { badge.textContent = (badge.getAttribute('data-tpl') || '').replace('[percent]', pct); badge.hidden = pct === 0; }
    }

    function unitVariant(unitEl) {
      var opts = $$('select[data-hc-unit-opt]', unitEl).map(function (s) { return s.value; });
      return findVariant(opts);
    }

    function updateTiers() {
      $$('[data-hc-tier]', root).forEach(function (tier) {
        var q = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var d = parseFloat(tier.getAttribute('data-discount')) || 0;
        var amt = parseInt(tier.getAttribute('data-amount'), 10) || 0;
        if (P.currency && P.shopCurrency && P.currency !== P.shopCurrency && tier.getAttribute('data-amount-local') !== 'true') {
          var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
          amt = Math.round((parseInt(tier.getAttribute('data-amount-shop'), 10) || 0) * rate);
        }
        var total = 0, cmp = 0;
        var units = $$('[data-hc-unit]', tier);
        if (tier.classList.contains('is-active') && units.length) {
          units.forEach(function (u) { var v = unitVariant(u) || current; total += v.price; cmp += (v.compare > v.price ? v.compare : v.price); });
        } else {
          total = current.price * q; cmp = (current.compare > current.price ? current.compare : current.price) * q;
        }
        var final = Math.max(0, Math.round(total * (100 - d) / 100) - amt);
        var tp = $('[data-hc-tp]', tier), tc = $('[data-hc-tc]', tier);
        if (tp) tp.textContent = money(final);
        if (tc) { tc.textContent = money(cmp); tc.hidden = cmp <= final; }
      });
    }

    function syncFirstUnits(opts) {
      $$('[data-hc-tier]', root).forEach(function (tier) {
        var u = $('[data-hc-unit]', tier);
        if (!u) return;
        $$('select[data-hc-unit-opt]', u).forEach(function (s, k) { if (opts[k] != null) s.value = opts[k]; });
      });
    }

    function updateButton(v) {
      var btn = $('[data-hc-atc]', root), idEl = $('[data-hc-variant]', root);
      if (idEl) idEl.value = v ? v.id : '';
      if (!btn) return;
      var ok = v && v.available;
      btn.disabled = !ok;
      btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
    }

    function onOptions(fromUser) {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) { updateButton(null); return; }
      current = v;
      updatePrice(v);
      updateButton(v);
      syncFirstUnits(opts);
      updateTiers();
      if (fromUser) {
        if (v.media && gallery) gallery.showMedia(v.media);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }

    if (optsEl) optsEl.addEventListener('change', function () { onOptions(true); });

    root.addEventListener('change', function (e) {
      var tierInput = e.target.closest('[data-hc-tier] > input[type="radio"]');
      if (tierInput) {
        $$('[data-hc-tier]', root).forEach(function (t) { t.classList.toggle('is-active', t.contains(tierInput)); });
        updateTiers();
        return;
      }
      var unitSel = e.target.closest('select[data-hc-unit-opt]');
      if (unitSel) {
        var unit = unitSel.closest('[data-hc-unit]');
        var tier = unitSel.closest('[data-hc-tier]');
        /* La 1re unité pilote aussi les pastilles du haut */
        if (unit && tier && $('[data-hc-unit]', tier) === unit && optsEl) {
          $$('select[data-hc-unit-opt]', unit).forEach(function (s, k) {
            var inp = $$('[data-hc-opt="' + k + '"] input', optsEl).filter(function (i) { return i.value === s.value; })[0];
            if (inp) inp.checked = true;
          });
          onOptions(true);
        } else {
          updateTiers();
        }
        return;
      }
      if (e.target.matches('[data-hc-addon-check]')) return;
    });

    /* Les selects d'unité sont dans un <label> : un clic ne doit pas changer de lot */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-hc-vars]') && e.target.tagName === 'SELECT') e.stopPropagation();
      var step = e.target.closest('[data-hc-step]');
      if (step) {
        var row = step.closest('[data-hc-addon]');
        var q = $('[data-hc-addon-q]', row);
        var n = Math.max(1, Math.min(10, (parseInt(q.textContent, 10) || 1) + parseInt(step.getAttribute('data-hc-step'), 10)));
        q.textContent = n;
        var chk = $('[data-hc-addon-check]', row);
        if (chk) chk.checked = true;
      }
    });

    var atc = $('[data-hc-atc]', root);
    if (atc) atc.addEventListener('click', function () {
      if (atc.disabled || atc.getAttribute('aria-busy') === 'true') return;
      var err = $('[data-hc-err]', root);
      if (err) err.textContent = '';
      var map = {}, order = [];
      function push(id, q) { if (!id) return; id = Number(id); if (!map[id]) { map[id] = 0; order.push(id); } map[id] += q; }
      var active = $('[data-hc-tier].is-active', root);
      if (active) {
        var units = $$('[data-hc-unit]', active);
        if (units.length) units.forEach(function (u) { var v = unitVariant(u); push(v ? v.id : current.id, 1); });
        else push(current.id, parseInt(active.getAttribute('data-qty'), 10) || 1);
      } else {
        push(current.id, 1);
      }
      $$('[data-hc-addon]', root).forEach(function (row) {
        var c = $('[data-hc-addon-check]', row);
        if (!c || !c.checked) return;
        var idEl = $('[data-hc-addon-id]', row);
        push(idEl && idEl.value, parseInt($('[data-hc-addon-q]', row).textContent, 10) || 1);
      });
      var items = order.map(function (id) { return { id: id, quantity: map[id] }; });
      atc.setAttribute('aria-busy', 'true');
      var label = atc.textContent;
      addToCart(items).then(function () {
        atc.removeAttribute('aria-busy');
        atc.textContent = label;
      }).catch(function (ex) {
        atc.removeAttribute('aria-busy');
        atc.textContent = label;
        if (err) err.textContent = ex.message;
      });
    });

    onOptions(false);
  }

  function init() {
    $$('[data-hc-main]').forEach(function (el) { if (!el.__hc) { el.__hc = true; initMain(el); } });
    $$('[data-hc-ship]').forEach(function (el) { if (!el.__hc) { el.__hc = true; initShip(el); } });
    $$('[data-hc-rv]').forEach(function (el) { if (!el.__hc) { el.__hc = true; initReviews(el); } });
    $$('[data-hc-cd]').forEach(function (el) { if (!el.__hc) { el.__hc = true; initCountdown(el); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
